import { readCookies as j } from "./cookies/cookie-parser-util.js";
import { GA_CLIENT_ID_COOKIE_NAME as x, parseGaClientIdCookie as L } from "./cookies/ga-client-id.js";
import { ErrorResponse as B, createErrorResponse as N } from "./errorResponse.js";
import { REPUBS as u } from "@cx-modules/constants";
import { getUserGroup as G } from "./getUserGroup.js";
import { SUPPORTED_REPUB_NAMES as l, REPUB_COUNTRY as f } from "@cx-web/domain-types";
import { g as c, a as m } from "./chunks/repubs-CAwWLC-I.js";
import { r as q, b as y } from "./chunks/repubs-CAwWLC-I.js";
const R = (e) => {
  if (e.status !== "rejected")
    return e.value;
}, E = (e, t) => {
  const r = R(e);
  if (r == null)
    throw new Response(null, { status: 500, statusText: t });
  return r;
}, w = (e, t) => {
  if (e.status === "rejected")
    throw e.reason instanceof Response ? e.reason : new Response(null, { status: 500, statusText: t });
  if (e.value == null)
    throw new Response(null, { status: 500, statusText: t });
  return e.value;
};
function b(e) {
  return !!u[e];
}
function O(e) {
  var r;
  const t = (r = e.pathname.split("/")[1]) == null ? void 0 : r.toUpperCase();
  return !b(t) || !u[t] ? u.OC.name : t;
}
const U = (e) => typeof e == "object" && e !== null && "status" in e;
function d(e) {
  const t = Object.entries(u).reduce((o, [a, p]) => ({
    ...o,
    [a]: e === p.name
  }), {}), r = e.toLowerCase(), n = l.some((o) => t[o]), s = n ? f[e] : "uk";
  return {
    repubIs: t,
    repubIsOCPlus: n,
    repubPath: m(e),
    repubHomeUrl: c(e),
    repubLowerCase: r,
    repubCountry: s
  };
}
function h(e) {
  const { repubIsOCPlus: t } = d(e);
  return t;
}
let i = /* @__PURE__ */ new WeakSet();
function I(e, t, r) {
  if (!i.has(e)) {
    e.init({
      lng: t,
      fallbackLng: "en-US",
      defaultNS: "label",
      resources: r,
      initImmediate: !1
    }), i.add(e);
    return;
  }
  e.language !== t && e.changeLanguage(t);
  for (const [n, s] of Object.entries(r))
    if (s)
      for (const [o, a] of Object.entries(s))
        e.addResourceBundle(n, o, a, !1, !0);
}
export {
  B as ErrorResponse,
  x as GA_CLIENT_ID_COOKIE_NAME,
  N as createErrorResponse,
  R as getPromiseResult,
  O as getRepubFromURL,
  c as getRepubHomeUrl,
  d as getRepubMetaFromRepub,
  m as getRepubPath,
  G as getUserGroup,
  U as isErrorWithStatus,
  h as isOcPlusRepub,
  b as isValidRepub,
  L as parseGaClientIdCookie,
  j as readCookies,
  q as removeRepubPrefix,
  y as repubs,
  w as requireErrorAwarePromiseResult,
  E as requirePromiseResult,
  I as updateI18nSingleton
};
